import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert } from "../Alerts/actions";
import { getTransferPackSuccess, getTransferPackFailure } from "./actions";
import { GET_TRANSFER_PACK } from "./constants";

export function* getTransferPackSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/resident/${payload}/transfer-pack`,
    );
    yield put(getTransferPackSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(getTransferPackFailure());
    yield put(errorAlert("Error fetching transfer pack"));
  }
}

export function* getTransferPackFlow() {
  yield takeEvery(GET_TRANSFER_PACK, getTransferPackSaga);
}

export default function* TransferPackSaga() {
  yield all([getTransferPackFlow()]);
}
